import CaseTaskBadgeForCaseStatus from "@/components/Table/MrtCaseFilters/CaseTaskBadgeForCaseStatus.tsx";
import NotificationBadgeForCaseStatus from "@/components/Table/MrtCaseFilters/NotificationBadgeForCaseStatus.tsx";
import TabBadges from "@/components/Table/MrtCaseFilters/TabBadges.tsx";
import { Button, ButtonGroup } from "@mui/material";

type Props = {
    selectedTab: string;
    setSelectedTab: (selectedTab: string) => void;
};

const IntakeSpecialistFilters = ({ selectedTab, setSelectedTab }: Props) => {
    return (
        <ButtonGroup aria-label="Basic button group" fullWidth sx={{ mb: 2 }}>
            <Button
                onClick={() => setSelectedTab("")}
                variant={selectedTab === "" ? "contained" : "outlined"}
            >
                All Cases
                <TabBadges />
            </Button>
            <Button
                onClick={() => setSelectedTab("New Client")}
                variant={selectedTab === "New Client" ? "contained" : "outlined"}
            >
                New Client
                <NotificationBadgeForCaseStatus caseStatus="New Client" />
                <CaseTaskBadgeForCaseStatus caseStatus="New Client" />
            </Button>
            <Button
                onClick={() => setSelectedTab("Withdrawal Pending")}
                variant={selectedTab === "Withdrawal Pending" ? "contained" : "outlined"}
            >
                Withdrawal Pending
                <NotificationBadgeForCaseStatus caseStatus="Withdrawal Pending" />
                <CaseTaskBadgeForCaseStatus caseStatus="Withdrawal Pending" />
            </Button>
            <Button
                onClick={() => setSelectedTab("Contract Sent")}
                variant={selectedTab === "Contract Sent" ? "contained" : "outlined"}
            >
                Contract Sent
                <NotificationBadgeForCaseStatus caseStatus="Contract Sent" />
                <CaseTaskBadgeForCaseStatus caseStatus="Contract Sent" />
            </Button>
        </ButtonGroup>
    );
};

export default IntakeSpecialistFilters;
